import { ModuleWithProviders, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { reducers } from './reference-data.reducers';
import { StoreModule } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { ReferenceDataEffects } from './reference-data.effects';
import { ReferenceDataManagementUiLibraryService } from './reference-data-management-ui-library.service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    StoreModule.forFeature('referenceData', reducers),
    EffectsModule.forFeature([
      ReferenceDataEffects,
    ]),
  ],
  providers: [
    ReferenceDataManagementUiLibraryService,
  ],
})
export class ReferenceDataManagementUiLibraryModule {
}
